export default __webpack_public_path__ + "static/media/oola_logo_blue.18a570f3.svg";